import React, { useState } from 'react';
import {
  SectionContainer,
  TextPairingContainer,
  StyledLeftImageWrapper,
  StyledRightImageWrapper,
  ColumnWrapper,
  StyleMiddleColumn,
  StyledDesktopPrintsImage,
  StyledMobilePrintsImage,
  MobileWrapper,
} from './HighQualityPrintsSection.styles';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { CTALink } from '@components/CTALink';
import ReactHtmlParser from 'react-html-parser';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

const analytics = require('../../../../static/js/joy');

export const HighQualityPrintsSection: React.FC = () => {
  const { t } = useTranslation('weddingInvitations');
  const highQualityPrintsSection = t('highQualityPrintsSection');

  const sectionId = 'HighQualityPrintsSection';

  const handlePrintPartnersClick = (printParterType: 'paperlust' | 'paperculture') => {
    analytics.segment.sendTelemetryEvent('printPartnerRedirect', { label: printParterType, value: printParterType });
  };
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleMobile, setIsVisibleMobile] = useState(false);
  return (
    <SectionContainer id={sectionId}>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <div />
      </LazyLoadWrapper>
      <MobileWrapper>
        <LazyLoadWrapper beforeLoad={() => setIsVisibleMobile(true)}>
          <div />
        </LazyLoadWrapper>
      </MobileWrapper>
      <ColumnWrapper fluid centered>
        <Columns.Column width={3}>
          <StyledLeftImageWrapper>
            <StyledDesktopPrintsImage isMainSrcShown={isVisible} src={'invites-gallery/floral-crown-g-v2.png'} />
            <StyledMobilePrintsImage isMainSrcShown={isVisibleMobile} src={'invites-gallery/floral-crown-g-mobile.png'} />
          </StyledLeftImageWrapper>
        </Columns.Column>
        <Columns.Column width={6}>
          <StyleMiddleColumn paddingTop={[10, 0]} paddingBottom={[6, 0]} paddingX={[6, 0]} flexDirection="column" alignItems="center">
            <TextPairingContainer
              eyebrow={highQualityPrintsSection.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant={'sectionEyeBrow20'}
              eyebrowTagName="h2"
              alignment={'center'}
              title={ReactHtmlParser(highQualityPrintsSection.title)}
              titleVariant={'hed72Hero'}
              titleColor="neutra6"
              titleTagName="h2"
              body={highQualityPrintsSection.body}
              bodyColor="neutra6"
              bodyVariant="dek20"
            />
            <Flex marginTop={[8]}>
              <Flex flexDirection="column">
                <CTALink
                  id="paperlust-engagement-invitations-icon"
                  href="https://paperlust.co/browse/wedding-invitations/?utm_source=joy&utm_medium=link&utm_campaign=partnership"
                  onClick={() => handlePrintPartnersClick('paperlust')}
                  aria-label="Paperlust"
                >
                  <CloudImage width="130px" height="50px" src="invites-gallery/pl-logo.svg" />
                </CTALink>
                <Box marginTop={[4]}>
                  <CTALink
                    id="paperlust-engagement-invitations"
                    hasChevron={true}
                    typography="featureHed17"
                    href="https://paperlust.co/browse/wedding-invitations/?utm_source=joy&utm_medium=link&utm_campaign=partnership"
                    onClick={() => handlePrintPartnersClick('paperlust')}
                  >
                    {highQualityPrintsSection.exploreDesigns}
                  </CTALink>
                </Box>
              </Flex>
              <Flex marginLeft={[8, 10]} flexDirection="column">
                <CTALink
                  id="paperculture-wedding-invitations-icon"
                  href="https://www.paperculture.com/wedding-invitations?utm_source=joy&utm_medium=link&utm_campaign=partnership"
                  onClick={() => handlePrintPartnersClick('paperculture')}
                  aria-label="Paperculture"
                >
                  <CloudImage width="130px" height="50px" src="invites-gallery/pc-logo.svg" />
                </CTALink>
                <Box marginTop={[4]}>
                  <CTALink
                    id="paperculture-wedding-invitations"
                    hasChevron={true}
                    typography="featureHed17"
                    href="https://www.paperculture.com/wedding-invitations?utm_source=joy&utm_medium=link&utm_campaign=partnership"
                    onClick={() => handlePrintPartnersClick('paperculture')}
                  >
                    {highQualityPrintsSection.exploreDesigns}
                  </CTALink>
                </Box>
              </Flex>
            </Flex>
          </StyleMiddleColumn>
        </Columns.Column>
        <Columns.Column width={3}>
          <StyledRightImageWrapper>
            <StyledDesktopPrintsImage isMainSrcShown={isVisible} src={'invites-gallery/bohemian-floral-v2.png'} />
            <StyledMobilePrintsImage isMainSrcShown={isVisibleMobile} src={'invites-gallery/bohemian-floral-mobile.png'} />
          </StyledRightImageWrapper>
        </Columns.Column>
      </ColumnWrapper>
    </SectionContainer>
  );
};
